import NotAllowed from '@/fsd/pages/not-allowed/ui/NotAllowed';
import { JSX } from 'react';

import Counterparty from '@fsd/pages/counterparties';

export type AppRoute = {
  title: string;
  path: string;
  section: string;
  element?: JSX.Element;
};

export const routes: Record<string, AppRoute> = {
  account: {
    title: 'Учетная запись',
    path: '/settings/account/',
    section: 'account',
  },
  organisations: {
    title: 'Организации и API',
    path: '/settings/account/api/',
    section: 'organisations_and_api',
  },
  sberOAuthConfirm: {
    title: 'Подтверждение СберБизнес',
    path: '/settings/account/api/sber/confirm/',
    section: 'account',
  },
  articleManagement: {
    title: 'Статьи',
    path: '/settings/articles/',
    section: 'articles',
  },
  closingPeriods: {
    title: 'Закрытие периодов',
    path: '/settings/closing-periods',
    section: 'period_closure',
  },
  staffs: {
    title: 'Доступы и сотрудники',
    path: '/settings/staff/',
    section: 'access',
  },
  counterparties: {
    title: 'Контрагенты',
    path: '/settings/counterparty/',
    section: 'counterparties',
  },
  warehouses: {
    title: 'Склады',
    path: '/settings/warehouse/',
    section: 'warehouses',
  },
  notices: {
    title: 'Уведомления',
    path: '/settings/notices/',
    section: 'notices',
  },
  rnp: {
    title: 'РНП',
    path: '/rnp/',
    section: 'rnp',
  },
  returns: {
    title: 'Возвраты',
    path: '/returns/',
    section: 'returns',
  },
  orders: {
    title: 'Заказы',
    path: '/purchase/orders/',
    section: 'orders',
  },
  acceptance: {
    title: 'Приемки',
    path: '/purchase/acceptance/',
    section: 'acceptances',
  },
  shipment: {
    title: 'Отгрузки',
    path: '/purchase/shipment/',
    section: 'shipments',
  },
  movement: {
    title: 'Премещения',
    path: '/purchase/movement/',
    section: 'movement',
  },
  remains: {
    title: 'Остатки',
    path: '/purchase/stocks/',
    section: 'stock',
  },
  pnl: {
    title: 'ОПиУ (P&L)',
    path: '/reports/',
    section: 'pnl',
  },
  dds: {
    title: 'ДДС (Cashflow)',
    path: '/financing/dds/',
    section: 'cashflow',
  },
  balance: {
    title: 'Баланс',
    path: '/reports/balance/',
    section: 'balance',
  },
  banks: {
    title: 'Банки',
    path: '/financing/banks/',
    section: 'banks',
  },
  rules: {
    title: 'Правила',
    path: '/financing/rules/',
    section: 'bank_rules',
  },
  cashbox: {
    title: 'Кассы',
    path: '/financing/cashbox/',
    section: 'cashboxes',
  },
  fot: {
    title: 'ФОТ',
    path: '/staff/',
    section: 'fot',
  },
  loans: {
    title: 'Займы',
    path: '/financing/loans/',
    section: 'loans',
  },
  answeringMachine: {
    title: 'Автоответчик на отзывы',
    path: '/scheduler/answering',
    section: 'answering_machine',
  },
  notAllowed: {
    title: 'Запрещенная страница',
    path: '/403/',
    section: 'not_allowed',
  },
  home: { title: 'Главная', path: '/', section: 'home' },
    policy: { title: 'Политика', path: '/policy', section: 'policy' },
  terms: { title: 'Пользовательское соглашение', path: '/terms', section: 'terms' },
  price: { title: 'Тарифы и цены', path: '/price', section: 'price' },
  signup: { title: 'Регистрация', path: '/signup', section: 'signup' },
  login: { title: 'Вход', path: '/login', section: 'login' },
  yandexCallback: {
    title: 'Авторизация через Яндекс',
    path: '/yandex/callback/',
    section: 'yandex_callback',
  },
  chooseCabinet: {
    title: 'Выберите кабинет',
    path: '/choose-cabinet',
    section: 'choose_cabinet',
  },
  passwordReset: {
    title: 'Восстановление пароля',
    path: '/password-reset/',
    section: 'password_reset',
  },
  costPrice: {
    title: 'Себестоимость',
    path: '/cost-price',
    section: 'cost_price',
  },
  cashboxItem: {
    title: 'Статья кассы',
    path: '/financing/cashbox/item/:id?',
    section: 'cashbox_item',
  },
  planfact: {
    title: 'План/Факт',
    path: '/financing/planfact/',
    section: 'plan_fact',
  },
  orderItem: {
    title: 'Заказ',
    path: '/purchase/orders/item/:id?',
    section: 'order_item',
  },
  acceptanceItem: {
    title: 'Приемка',
    path: '/purchase/acceptance/item/:id?',
    section: 'acceptance_item',
  },
  shipmentItem: {
    title: 'Отгрузка',
    path: '/purchase/shipment/item/:id?',
    section: 'shipment_item',
  },
  movementItem: {
    title: 'Перемещение',
    path: '/purchase/movement/item/:id?',
    section: 'movement_item',
  },
  logistics: {
    title: 'Логистика',
    path: '/scheduler/logistics',
    section: 'logistics',
  },
  logisticsSettings: {
    title: 'Настройки логистики',
    path: '/scheduler/logistics/settings',
    section: 'logistics_settings',
  },
  logisticsEdit: {
    title: 'Редактирование логистики',
    path: '/scheduler/logistics/edit/:id',
    section: 'logistics_edit',
  },
  answeringMachineEdit: {
    title: 'Редактирование автоответчика',
    path: '/scheduler/answering/item/:id/:type',
    section: 'answering_machine_edit',
  },
  projects: {
    title: 'Проекты',
    path: '/analytics/projects/',
    section: 'projects',
  },
  projectItem: {
    title: 'Проект',
    path: '/analytics/projects/item/:id',
    section: 'project_item',
  },
  employeeCard: {
    title: 'Карточка сотрудника',
    path: '/staff/card/:id',
    section: 'employee_card',
  },
  advertisement: {
    title: 'Реклама',
    path: '/reports/advertisement/',
    section: 'advertisement',
  },
  economy: { title: 'Экономика', path: '/economy/:type', section: 'economy' },
  sails: { title: 'Продажи', path: '/sails', section: 'sails' },
  faq: { title: 'FAQ', path: '/faq', section: 'faq' },
  faqArticle: {
    title: 'Статья FAQ',
    path: '/faq/article/:id',
    section: 'faq_article',
  },
  faqCategories: {
    title: 'Категории FAQ',
    path: '/faq/categories/:id',
    section: 'faq_categories',
  },
  tariffsAndPayments: {
    title: 'Тарифы и платежи',
    path: '/tariffs-and-payments',
    section: 'tariffs_and_payments',
  },
  requestsForSupply: {
    title: 'Заявки на поставку',
    path: '/requests-for-supply',
    section: 'requests_for_supply',
  },
  requestsForSupplyItem: {
    title: 'Заявка на поставку',
    path: '/requests-for-supply/item/:id?',
    section: 'requests_for_supply_item',
  },
  mutualSettlements: {
    title: 'Сверка',
    path: '/mutual-settlements/',
    section: 'mutual_settlements',
  },
  serverError: {
    title: 'Ошибка сервера',
    path: '/500',
    section: 'server_error',
  },
  notFound: { title: 'Не найдено', path: '/*', section: 'not_found' },
};
